import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const [azureBatchSizeError, setAzureBatchSizeError] = useState(false);
  const [azureWaitTimeError, setAzureWaitTimeError] = useState(false);
  const { azureBatchSize, azureWaitTime, contentTypes } = formData;
  const availableContent = [
    { label: "Azure Services", value: "AZURE_SERVICES" },
    { label: "JSON Array", value: "JSON_ARRAY" },
    { label: "Raw Text/Single JSON document", value: "TEXT" },
    { label: "GELF (Newline Delimited)", value: "GELF_BATCH" },
    { label: "Text (Newline Delimited)", value: "TEXT_BATCH" }
  ];
  const [contentTypesState, setContentTypesState] = useState(contentTypes.value || "");
  const [contentTypeVal] = useState(false);
  const handleSubmit = () => {
    formData.contentTypes.value = contentTypesState;
    let error = false;
    if (azureBatchSize.value < 1 || azureBatchSize.value > 1e3) {
      error = true;
      setAzureBatchSizeError(true);
    }
    if (azureWaitTime.value < 1 || azureWaitTime.value > 30) {
      error = true;
      setAzureWaitTimeError(true);
    }
    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, "Content Type"), /* @__PURE__ */ React.createElement(
    Select,
    {
      name: "content_types",
      id: "contentTypes",
      onChange: (selected) => setContentTypesState(selected),
      options: availableContent,
      value: contentTypesState || ""
    }
  ), contentTypeVal && contentTypesState.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes" }, "Select at least one"), /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The content type of your log files."), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "azureBatchSize",
      name: "azureBatchSize",
      type: "number",
      value: azureBatchSize.value || azureBatchSize.defaultValue || "",
      min: "10",
      max: "20000",
      onChange,
      required: true,
      help: "The Maximum message count received from Event Hub at once. The input will store checkpoints once per batch.",
      label: "Maximum Batch Size"
    }
  ), azureBatchSizeError && /* @__PURE__ */ React.createElement("span", null, " ", /* @__PURE__ */ React.createElement("strong", null, "The Maximum Batch Size must be greater than 1.")), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "azureWaitTime",
      name: "azureWaitTime",
      type: "number",
      value: azureWaitTime.value || azureWaitTime.defaultValue || "",
      min: "1",
      max: "30",
      onChange,
      required: true,
      help: "The maximum amount of time to wait for the Maximum Batch Size to be reached. The average wait time is 3 minutes",
      label: "Maximum Wait Time"
    }
  ), azureWaitTimeError && /* @__PURE__ */ React.createElement("span", null, " ", /* @__PURE__ */ React.createElement("strong", null, "The wait time can be between 1 to 30")), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange }));
};
export default StepSubscribe;
